import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useStakingsData } from "@src/contexts/StakingsDataContext";
import { convertMiliseconds } from "@src/utils/convertMiliseconds";
import { formatDate } from "@src/utils/formatDateTime";

import Stack from "@src/components/arrangement/Stack/Stack";
import DaysProgressBar from "@src/components/dataDisplay/DaysProgressBar/DaysProgressBar";

const PrelaunchBefore = () => {
  const { instancesData } = useStakingsData();

  const { t } = useTranslation("staking");
  const { t: commonT } = useTranslation("common");

  const startDate = useMemo(() => {
    return new Date(instancesData?.[0].stages.subscribeStageFrom || 0);
  }, [instancesData]);

  const subscribeStageFrom = useMemo(() => {
    return instancesData?.[0].stages.subscribeStageFrom || 0;
  }, [instancesData]);

  const subscribeStageTo = useMemo(() => {
    return instancesData?.[0].stages.subscribeStageTo || 0;
  }, [instancesData]);

  const prelaunchDuration = convertMiliseconds(subscribeStageTo - subscribeStageFrom, "DAYS");
  const beforeInfo = `${prelaunchDuration} ${commonT("days")}`;

  return (
    <Stack rowGap={48} className="mt-3">
      <DaysProgressBar beforeInfo={beforeInfo} />
      <h2 className="gradient-text">{t("prelaunchStage.before.title", { date: formatDate(startDate) })}</h2>
    </Stack>
  );
};

export default PrelaunchBefore;
